if (!customElements.get('announcement-bar-slider')) {
  class AnnouncementBarSlider extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.timer = null;
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      this.wrapper = this.querySelector('.swiper-wrapper');
      if (!this.wrapper) return;

      this.slides = Array.from(this.wrapper.children);
      if (!this.slides.length) return;

      this.autoplayInterval = Number(this.dataset.autoplayInterval) || 3000;

      this.wrapper.style.transition = 'transform 0.4s ease';
      this.wrapper.style.display = 'flex';

      this.slides.forEach(slide => {
        slide.style.flex = '0 0 100%';
      });

      this.startAutoplay();
    }

    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
      this.wrapper.style.transform = `translateX(-${this.currentIndex * 100}%)`;
    }

    startAutoplay() {
      this.stopAutoplay();

      if (this.slides.length <= 1) return;

      this.timer = setInterval(() => {
        this.nextSlide();
      }, this.autoplayInterval);
    }

    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }
  }

  customElements.define('announcement-bar-slider', AnnouncementBarSlider);
}